import {fetchNonces} from '@github-ui/fetch-nonce'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import '@github/include-fragment-element'

if (ssrSafeWindow) {
  ssrSafeWindow.IncludeFragmentElement.prototype.fetch = function (request: Request) {
    const nonce = this.getAttribute('data-nonce') || ''

    if (fetchNonces.has(nonce)) {
      request.headers.set('X-Fetch-Nonce', nonce)
    } else {
      // TODO: stop sending full list of nonces. We are doing this now to collect stats
      // and make debugging easier.
      request.headers.set('X-Fetch-Nonce', Array.from(fetchNonces).join(','))
    }

    request.headers.set('X-Requested-With', 'XMLHttpRequest')
    request.headers.set('X-Fetch-Nonce-To-Validate', nonce)
    return window.fetch(request)
  }
}
